export default function ({ router, i18n }) {

  function skipHome(to, from, next) {
    if (to.name === 'home') {
      const locale = i18n.locale
      return next({ name: 'list', params: { locale } })
    }
    return next()
  }

  function setDefaultLocale(to, from, next) {
    if (!to.params.locale) {
      const locale = i18n.locale
      const name = to.name
      return next({ name, params: { ...to.params, locale }, query: to.query, replace: true })
    }
    return next()
  }

  function setResetLayout(to, from, next) {
    if(to.name == 'story') {
      window.scroll(0, 0)
      if(document.querySelector('.topbar-especial')) {        
        document.querySelector('.topbar-especial').style.background = `transparent`
        document.querySelector(`.navigation_stories`).classList.remove('active_nav')  
        document.querySelector(`.topbar-especial`).classList.remove('active_nav')
      }
    } else if(to.name == 'list' && (from.query.creditos=='show' ||  to.query.creditos=='show')) {
      if(document.querySelector('#creditos-container')) {
        let top = document.querySelector('#creditos-container').offsetTop
        console.log("test")
        window.scroll(top, top)
      }
    }
    return next()
  }

  router.beforeEach(skipHome)
  router.beforeEach(setDefaultLocale)
  router.beforeEach(setResetLayout)
}